import { ApiClient } from '../apiClient';

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

export class ContactService {
  constructor(private apiClient: ApiClient) {}

  /**
   * Submit contact form
   */
  async submitContactForm(formData: ContactFormData): Promise<ContactResponse> {
    return this.apiClient.post<ContactResponse>('/contact', formData);
  }
}
